import React from "react";
import { useSelector } from "react-redux";

import "../styles/suspended.css"
import suspend from '../assets/suspend.jpg'
const Suspended = () => {
  const { account } = useSelector((state) => state.accounts);

  return (
    <>
      <div className="suspended">
        <div class="sus-header"></div>
        <div className="headt">
          <div className="img" style={{ backgroundImage: `url(${suspend})` }}></div>
          <div className="inf">
            <h2>No Access</h2>
            <p>You have been denied access because your account violates our code of conduct. Refer below for reasons for this action and how to resolve it.</p>
          </div>
        </div>
        <div className="container">
          <div className="cont">
            <h3>Why was my account suspended and how can i resolve it?</h3>
            <p>{account?.suspension?.reason}</p>
          </div>
        </div>
        <div className="more">
          <p>Please contact support via livechat for more enquiries, download your data</p>
        </div>
      </div>
    </>
  )
}

export default Suspended